// This contains entities that are renamed from "Build*" to "Pipeline*"
// This file should be kept in synch with the following file (in new web platform)
// Tfs\Web\extensions\analytics\vss-analyticsshared-web\Shared\Common\PipelineEntities.ts
export let Pipelines = "BuildPipelines";
export let Pipeline = "BuildPipeline";

export let PipelineSK = "BuildPipelineSK";
export let PipelineId = "BuildPipelineId";
export let PipelineName = "BuildPipelineName";
export let PipelineVersion = "BuildPipelineVersion";
export let PipelineProcessType = "BuildPipelineProcessType";

export let PipelineRuns = "Builds";
export let PipelineRun = "Build";

export let PipelineRunSK = "BuildSK";
export let PipelineRunId = "BuildId";
export let PipelineRunNumber = "BuildNumber";
export let PipelineRunNumberRevision = "BuildNumberRevision";
export let PipelineRunOutcome = "BuildOutcome";
export let PipelineRunReason = "BuildReason";
export let PipelineRunDurationSeconds = "BuildDurationSeconds";

export let PipelineRunActivityResults = "BuildTaskResults";
export let PipelineRunActivityResult = "BuildTaskResult";

export let PipelineRunTaskResultSK = "BuildTaskResultSK";
export let PipelineRunQueuedDateSK = "BuildQueuedDateSK";
export let PipelineRunQueuedOn = "BuildQueuedOn";
export let PipelineRunStartedDateSK = "BuildStartedDateSK";
export let PipelineRunStartedOn = "BuildStartedOn";
export let PipelineRunCompletedDateSK = "BuildCompletedDateSK";
export let PipelineRunCompletedOn = "BuildCompletedOn";
export let PipelineRunTaskOutcome = "BuildTaskOutcome";
export let PipelineTask = "BuildPipelineTask";

export let PipelineTaskSK = "BuildPipelineTaskSK";

export function switchEntityAndAttributeNames(): void {
    Pipelines = "Pipelines";
    Pipeline = "Pipeline";

    PipelineSK = "PipelineSK";
    PipelineId = "PipelineId";
    PipelineName = "PipelineName";
    PipelineVersion = "PipelineVersion";
    PipelineProcessType = "PipelineProcessType";

    PipelineRuns = "PipelineRuns";
    PipelineRun = "PipelineRun";

    PipelineRunSK = "PipelineRunSK";
    PipelineRunId = "PipelineRunId";
    PipelineRunNumber = "PipelineRunNumber";
    PipelineRunNumberRevision = "PipelineRunNumberRevision";
    PipelineRunOutcome = "PipelineRunOutcome";
    PipelineRunReason = "PipelineRunReason";
    PipelineRunDurationSeconds = "PipelineRunDurationSeconds";

    PipelineRunActivityResults = "PipelineRunActivityResults";
    PipelineRunActivityResult = "PipelineRunActivityResult";

    PipelineRunTaskResultSK = "PipelineRunTaskResultSK";
    PipelineRunQueuedDateSK = "PipelineRunQueuedDateSK";
    PipelineRunQueuedOn = "PipelineRunQueuedOn";
    PipelineRunStartedDateSK = "PipelineRunStartedDateSK";
    PipelineRunStartedOn = "PipelineRunStartedOn";
    PipelineRunCompletedDateSK = "PipelineRunCompletedDateSK";
    PipelineRunCompletedOn = "PipelineRunCompletedOn";
    PipelineRunTaskOutcome = "PipelineRunTaskOutcome";

    PipelineTask = "PipelineTask";
    PipelineTaskSK = "PipelineTaskSK";
}

export function switchEntityAndAttributesBackToBuild(): void {
    Pipelines = "BuildPipelines";
    Pipeline = "BuildPipeline";
    PipelineSK = "BuildPipelineSK";
    PipelineId = "BuildPipelineId";
    PipelineName = "BuildPipelineName";
    PipelineVersion = "BuildPipelineVersion";
    PipelineProcessType = "BuildPipelineProcessType";
    PipelineRuns = "Builds";
    PipelineRun = "Build";
    PipelineRunSK = "BuildSK";
    PipelineRunId = "BuildId";
    PipelineRunNumber = "BuildNumber";
    PipelineRunNumberRevision = "BuildNumberRevision";
    PipelineRunOutcome = "BuildOutcome";
    PipelineRunReason = "BuildReason";
    PipelineRunDurationSeconds = "BuildDurationSeconds";
    PipelineRunActivityResults = "BuildTaskResults";
    PipelineRunActivityResult = "BuildTaskResult";
    PipelineRunTaskResultSK = "BuildTaskResultSK";
    PipelineRunQueuedDateSK = "BuildQueuedDateSK";
    PipelineRunQueuedOn = "BuildQueuedOn";
    PipelineRunStartedDateSK = "BuildStartedDateSK";
    PipelineRunStartedOn = "BuildStartedOn";
    PipelineRunCompletedDateSK = "BuildCompletedDateSK";
    PipelineRunCompletedOn = "BuildCompletedOn";
    PipelineRunTaskOutcome = "BuildTaskOutcome";
    PipelineTask = "BuildPipelineTask";
    PipelineTaskSK = "BuildPipelineTaskSK";
}

export const RenameBuildEntitiesFeatureFlag = "WebAccess.Pipeline.Analytics.RenameBuildEntities";
